function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
}
function getScript(source, callback) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = function( _, isAbort ) {
        if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
            script.onload = script.onreadystatechange = null;
            script = undefined;

            if(!isAbort && callback) setTimeout(callback, 0);
        }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
}
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = ";SameSite=None;Secure;expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  if(document.querySelector('product-model')) {
	document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI.pause());
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('span').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.getAttribute("name") === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

  function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
      var context = this;
      var args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  };

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

var moneyFormats={USD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} USD"},EUR:{money_format:"&euro;{{amount}}",money_with_currency_format:"&euro;{{amount}} EUR"},GBP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} GBP"},CAD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} CAD"},ALL:{money_format:"Lek {{amount}}",money_with_currency_format:"Lek {{amount}} ALL"},DZD:{money_format:"DA {{amount}}",money_with_currency_format:"DA {{amount}} DZD"},AOA:{money_format:"Kz{{amount}}",money_with_currency_format:"Kz{{amount}} AOA"},ARS:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} ARS"},AMD:{money_format:"{{amount}} AMD",money_with_currency_format:"{{amount}} AMD"},AWG:{money_format:"Afl{{amount}}",money_with_currency_format:"Afl{{amount}} AWG"},AUD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} AUD"},BBD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} Bds"},AZN:{money_format:"m.{{amount}}",money_with_currency_format:"m.{{amount}} AZN"},BDT:{money_format:"Tk {{amount}}",money_with_currency_format:"Tk {{amount}} BDT"},BSD:{money_format:"BS${{amount}}",money_with_currency_format:"BS${{amount}} BSD"},BHD:{money_format:"{{amount}}0 BD",money_with_currency_format:"{{amount}}0 BHD"},BYR:{money_format:"Br {{amount}}",money_with_currency_format:"Br {{amount}} BYR"},BZD:{money_format:"BZ${{amount}}",money_with_currency_format:"BZ${{amount}} BZD"},BTN:{money_format:"Nu {{amount}}",money_with_currency_format:"Nu {{amount}} BTN"},BAM:{money_format:"KM {{amount_with_comma_separator}}",money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"},BRL:{money_format:"R$ {{amount_with_comma_separator}}",money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"},BOB:{money_format:"Bs{{amount_with_comma_separator}}",money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"},BWP:{money_format:"P{{amount}}",money_with_currency_format:"P{{amount}} BWP"},BND:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} BND"},BGN:{money_format:"{{amount}} лв",money_with_currency_format:"{{amount}} лв BGN"},MMK:{money_format:"K{{amount}}",money_with_currency_format:"K{{amount}} MMK"},KHR:{money_format:"KHR{{amount}}",money_with_currency_format:"KHR{{amount}}"},KYD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} KYD"},XAF:{money_format:"FCFA{{amount}}",money_with_currency_format:"FCFA{{amount}} XAF"},CLP:{money_format:"${{amount_no_decimals}}",money_with_currency_format:"${{amount_no_decimals}} CLP"},CNY:{money_format:"&#165;{{amount}}",money_with_currency_format:"&#165;{{amount}} CNY"},COP:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} COP"},CRC:{money_format:"&#8353; {{amount_with_comma_separator}}",money_with_currency_format:"&#8353; {{amount_with_comma_separator}} CRC"},HRK:{money_format:"{{amount_with_comma_separator}} kn",money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"},CZK:{money_format:"{{amount_with_comma_separator}} K&#269;",money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"},DKK:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"kr.{{amount_with_comma_separator}}"},DOP:{money_format:"RD$ {{amount}}",money_with_currency_format:"RD$ {{amount}}"},XCD:{money_format:"${{amount}}",money_with_currency_format:"EC${{amount}}"},EGP:{money_format:"LE {{amount}}",money_with_currency_format:"LE {{amount}} EGP"},ETB:{money_format:"Br{{amount}}",money_with_currency_format:"Br{{amount}} ETB"},XPF:{money_format:"{{amount_no_decimals_with_comma_separator}} XPF",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"},FJD:{money_format:"${{amount}}",money_with_currency_format:"FJ${{amount}}"},GMD:{money_format:"D {{amount}}",money_with_currency_format:"D {{amount}} GMD"},GHS:{money_format:"GH&#8373;{{amount}}",money_with_currency_format:"GH&#8373;{{amount}}"},GTQ:{money_format:"Q{{amount}}",money_with_currency_format:"{{amount}} GTQ"},GYD:{money_format:"G${{amount}}",money_with_currency_format:"${{amount}} GYD"},GEL:{money_format:"{{amount}} GEL",money_with_currency_format:"{{amount}} GEL"},HNL:{money_format:"L {{amount}}",money_with_currency_format:"L {{amount}} HNL"},HKD:{money_format:"${{amount}}",money_with_currency_format:"HK${{amount}}"},HUF:{money_format:"{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"},ISK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr ISK"},INR:{money_format:"Rs. {{amount}}",money_with_currency_format:"Rs. {{amount}}"},IDR:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"Rp {{amount_with_comma_separator}}"},ILS:{money_format:"{{amount}} NIS",money_with_currency_format:"{{amount}} NIS"},JMD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} JMD"},JPY:{money_format:"&#165;{{amount_no_decimals}}",money_with_currency_format:"&#165;{{amount_no_decimals}} JPY"},JEP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} JEP"},JOD:{money_format:"{{amount}}0 JD",money_with_currency_format:"{{amount}}0 JOD"},KZT:{money_format:"{{amount}} KZT",money_with_currency_format:"{{amount}} KZT"},KES:{money_format:"KSh{{amount}}",money_with_currency_format:"KSh{{amount}}"},KWD:{money_format:"{{amount}}0 KD",money_with_currency_format:"{{amount}}0 KWD"},KGS:{money_format:"лв{{amount}}",money_with_currency_format:"лв{{amount}}"},LVL:{money_format:"Ls {{amount}}",money_with_currency_format:"Ls {{amount}} LVL"},LBP:{money_format:"L&pound;{{amount}}",money_with_currency_format:"L&pound;{{amount}} LBP"},LTL:{money_format:"{{amount}} Lt",money_with_currency_format:"{{amount}} Lt"},MGA:{money_format:"Ar {{amount}}",money_with_currency_format:"Ar {{amount}} MGA"},MKD:{money_format:"ден {{amount}}",money_with_currency_format:"ден {{amount}} MKD"},MOP:{money_format:"MOP${{amount}}",money_with_currency_format:"MOP${{amount}}"},MVR:{money_format:"Rf{{amount}}",money_with_currency_format:"Rf{{amount}} MRf"},MXN:{money_format:"$ {{amount}}",money_with_currency_format:"$ {{amount}} MXN"},MYR:{money_format:"RM{{amount}} MYR",money_with_currency_format:"RM{{amount}} MYR"},MUR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} MUR"},MDL:{money_format:"{{amount}} MDL",money_with_currency_format:"{{amount}} MDL"},MAD:{money_format:"{{amount}} dh",money_with_currency_format:"Dh {{amount}} MAD"},MNT:{money_format:"{{amount_no_decimals}} &#8366",money_with_currency_format:"{{amount_no_decimals}} MNT"},MZN:{money_format:"{{amount}} Mt",money_with_currency_format:"Mt {{amount}} MZN"},NAD:{money_format:"N${{amount}}",money_with_currency_format:"N${{amount}} NAD"},NPR:{money_format:"Rs{{amount}}",money_with_currency_format:"Rs{{amount}} NPR"},ANG:{money_format:"&fnof;{{amount}}",money_with_currency_format:"{{amount}} NA&fnof;"},NZD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} NZD"},NIO:{money_format:"C${{amount}}",money_with_currency_format:"C${{amount}} NIO"},NGN:{money_format:"&#8358;{{amount}}",money_with_currency_format:"&#8358;{{amount}} NGN"},NOK:{money_format:"kr {{amount_with_comma_separator}}",money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"},OMR:{money_format:"{{amount_with_comma_separator}} OMR",money_with_currency_format:"{{amount_with_comma_separator}} OMR"},PKR:{money_format:"Rs.{{amount}}",money_with_currency_format:"Rs.{{amount}} PKR"},PGK:{money_format:"K {{amount}}",money_with_currency_format:"K {{amount}} PGK"},PYG:{money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"},PEN:{money_format:"S/. {{amount}}",money_with_currency_format:"S/. {{amount}} PEN"},PHP:{money_format:"&#8369;{{amount}}",money_with_currency_format:"&#8369;{{amount}} PHP"},PLN:{money_format:"{{amount_with_comma_separator}} zl",money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"},QAR:{money_format:"QAR {{amount_with_comma_separator}}",money_with_currency_format:"QAR {{amount_with_comma_separator}}"},RON:{money_format:"{{amount_with_comma_separator}} lei",money_with_currency_format:"{{amount_with_comma_separator}} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",money_with_currency_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"},RWF:{money_format:"{{amount_no_decimals}} RF",money_with_currency_format:"{{amount_no_decimals}} RWF"},WST:{money_format:"WS$ {{amount}}",money_with_currency_format:"WS$ {{amount}} WST"},SAR:{money_format:"{{amount}} SR",money_with_currency_format:"{{amount}} SAR"},STD:{money_format:"Db {{amount}}",money_with_currency_format:"Db {{amount}} STD"},RSD:{money_format:"{{amount}} RSD",money_with_currency_format:"{{amount}} RSD"},SCR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} SCR"},SGD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} SGD"},SYP:{money_format:"S&pound;{{amount}}",money_with_currency_format:"S&pound;{{amount}} SYP"},ZAR:{money_format:"R {{amount}}",money_with_currency_format:"R {{amount}} ZAR"},KRW:{money_format:"&#8361;{{amount_no_decimals}}",money_with_currency_format:"&#8361;{{amount_no_decimals}} KRW"},LKR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} LKR"},SEK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr SEK"},CHF:{money_format:"SFr. {{amount}}",money_with_currency_format:"SFr. {{amount}} CHF"},TWD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TWD"},THB:{money_format:"{{amount}} &#xe3f;",money_with_currency_format:"{{amount}} &#xe3f; THB"},TZS:{money_format:"{{amount}} TZS",money_with_currency_format:"{{amount}} TZS"},TTD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TTD"},TND:{money_format:"{{amount}}",money_with_currency_format:"{{amount}} DT"},TRY:{money_format:"{{amount}}TL",money_with_currency_format:"{{amount}}TL"},UGX:{money_format:"Ush {{amount_no_decimals}}",money_with_currency_format:"Ush {{amount_no_decimals}} UGX"},UAH:{money_format:"₴{{amount}}",money_with_currency_format:"₴{{amount}} UAH"},AED:{money_format:"Dhs. {{amount}}",money_with_currency_format:"Dhs. {{amount}} AED"},UYU:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} UYU"},VUV:{money_format:"${{amount}}",money_with_currency_format:"${{amount}}VT"},VEF:{money_format:"Bs. {{amount_with_comma_separator}}",money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"},VND:{money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"},XBT:{money_format:"{{amount_no_decimals}} BTC",money_with_currency_format:"{{amount_no_decimals}} BTC"},XOF:{money_format:"CFA{{amount}}",money_with_currency_format:"CFA{{amount}} XOF"},ZMW:{money_format:"K{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"}}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var currency
  
  currency = "BRL";
  
  if(moneyFormats[currency]) {
    var formatString = (format || moneyFormats[currency].money_format);
  }
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if(this.querySelector('.template-popup')) {
      this.querySelector('.template-popup').loadContent();
    }
    // trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');

    // removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if(button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if(document.querySelector(this.getAttribute('data-modal'))) {
          document.querySelector(this.getAttribute('data-modal')).show(button);
        }
      });
    }
    
    const a = this.querySelector('a:not(.btn-wishlist)');
    if(a) {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        if(document.querySelector(this.getAttribute('data-modal'))) {
          document.querySelector(this.getAttribute('data-modal')).show(a);
        }
      });
    }
  }

}
customElements.define('modal-opener', ModalOpener);
class scrollToTop extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function (event) {
      if ($(window).scrollTop() > 20) {
        $('.scroll-to-top').removeClass('hidden');
      } else {
        $('.scroll-to-top').addClass('hidden');
      }
      $(window).scroll(function(){
        if ($(this).scrollTop() > 20) {
          $('.scroll-to-top').removeClass('hidden');
        } else {
          $('.scroll-to-top').addClass('hidden');
        }
      });

      $(document).on('click', '.scroll-to-top', function(){
        $('html, body').animate({scrollTop: '0px'}, 800);
        return false;
      });
    });
  }

}
customElements.define('scroll-to-top', scrollToTop);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if(this.querySelector('[id^="Deferred-Poster-"]')) {
      this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class CurrencyPicker extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('change', this.onItemClick.bind(this)); 
    this.select = this.querySelector('select');
    this.select.addEventListener('change', this.onChange.bind(this))
  }
    
  onChange() {
    document.querySelector(".currency-picker").value = this.select.value
  }

  onItemClick(event) {
    event.preventDefault();
    let formData = new FormData(this.form);
    fetch(this.form.getAttribute("action"),{
      method: 'POST',
      body :  formData
    })
    .then(rs => rs.text())
    .then((data) => {
      const parsedHTML = new DOMParser().parseFromString(data, 'text/html');
      parsedHTML.querySelectorAll('[data-currency-id]').forEach(price => {
        let id = price.getAttribute("data-currency-id");
        if (id == 'placeholder') {
          document.querySelectorAll("[data-currency-id='placeholder']").forEach((span) => span.innerHTML = price.innerHTML);
          return;
        }
        if (typeof id !='undefined' && id != null){
          document.querySelectorAll("[data-currency-id='"+ id +"']").forEach( (dom) => dom.innerHTML = price.innerHTML );
        }
      })
    })
  }
}

customElements.define('currency-picker', CurrencyPicker);


 class CompareDialog extends ModalDialog {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            if (event.target.nodeName === 'COMPARE-DIALOG') {
                this.hide();
            }
        });

    }
    show(opener) {
        this.openedBy = opener;

        var compareProducts = [];

        var handle = this.openedBy.getAttribute('data-product-handle');
        if (typeof(Storage) !== "undefined") {
            if (localStorage.getItem("compareList")) {
              if (getCookie("compare-expire") === undefined) {
                localStorabrowserge.removeItem("compareList");
              } else {
                compareProducts = JSON.parse(localStorage.getItem("compareList"));
              }
            }
            if (handle && handle != '') {
                var inArray = false;
                for (var i = 0; i < compareProducts.length; i++) {
                  if (handle == compareProducts[i]) {
                    inArray = true;
                    break;
                  }
                }
                if(!inArray) {
                  compareProducts.unshift(handle);
                }

                if (compareProducts.length) {
                    var removeCompare = (e) => {
                      e.preventDefault();
                      var handle = e.target.getAttribute('data-product-handle');
                      if (compareProducts.length) {
                        document.querySelectorAll('td[data-compare-handle="'+handle+'"]').forEach(function(el) {
                          el.parentNode.removeChild(el);
                        }); 
                        for (var i = 0; i < compareProducts.length; i++) {
                          if (handle == compareProducts[i]) {
                            compareProducts.splice(i, 1);
                            break;
                          }
                        }
                        if(!compareProducts.length) {
                          this.showHideCompare(false);
                        }
                        localStorage.setItem("compareList", JSON.stringify(compareProducts));
                        setCookie("compare-expire", 1, 1);
                      }
                    }
                    document.querySelectorAll('.gp-popup-compare .compare-popup-content tr td').forEach(function(el) {
                      el.parentNode.removeChild(el);
                    }); 
                    for (var i = 0; i < compareProducts.length; i++) {
                        fetch('/products/'+ compareProducts[i] +'.js')
                        .then(response => response.json())
                        .then((product) => {
                          this.addProductHtmlToPopup(product);
                          this.querySelectorAll('.btn-remove-compare').forEach(function(el) {
                            el.addEventListener('click', (event) => removeCompare(event))
                          }); 
                        });
                    }
                    this.showHideCompare(true);
                } else {
                    this.showHideCompare(false);
                }
                localStorage.setItem("compareList", JSON.stringify(compareProducts));
                setCookie("compare-expire", 1, 1);
            } 
        } else {
            console.log('No Web Storage support..');
        }


        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
    }
   
    showHideCompare(isShow) {
        if (isShow) {
            this.querySelector('.compare-wrapper').style.display = "block";
            this.querySelector('.compare-wrapper-empty').style.display = "none";
        } else {
            this.querySelector('.compare-wrapper').style.display = "none";
            this.querySelector('.compare-wrapper-empty').style.display = "block";
        }
    }

    addProductHtmlToPopup(product) {
        var pImage = '<td data-compare-handle="'+product.handle+'"><span class="btn-remove-compare" data-product-handle="'+product.handle+'" title="'+ theme.strings.removeCompareProduct +'"></span><div class="image"><a href="'+ product.url +'" class="hover-change-img">';
        if (product.featured_image) {
          pImage += '<img src="'+ product.featured_image +'" alt="'+ product.title +'" width="200" height="200"/>';
        }
        if (product.images.size > 1) {
          pImage += '<img src="'+ product.images[1] +'" alt="'+ product.title +'"/>';
        }
        pImage += '</a></div></td>';
        var pPrice = '<td data-compare-handle="'+product.handle+'">';
        if (product.compare_at_price > product.price) {
          pPrice += '<div class="price price--on-sale" data-data-currency-id="'+product.id+'-compare">';
        } else {
          pPrice += '<div class="price" data-data-currency-id="'+product.id+'-compare">';
        }
        if (product.compare_at_price > product.price) {
          pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.compare_at_price) +'</span></span></div>';
        } else {
          pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
        }
        pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
        pPrice += '</div></td>';
        var pTitle = '<td data-compare-handle="'+product.handle+'">' + '<a href="'+product.url+'">' + product.title + '</a>' + '</td>';
        var pCart = '';
        if (product.available) {
          var variants = product.variants;
          if (variants.length > 1) {
            pCart = '<td data-compare-handle="'+product.handle+'"><modal-opener class="no-js-hidden" data-modal="#PopupModal-quickview"><a href="'+ product.url +'" class="btn--link active btn-select-option js-open-quickview" data-title="'+ theme.strings.selectOptionText +'"><span>'+ theme.strings.selectOptionText +'</span></a></modal-opener></td>';
          } else {
            pCart = '<td data-compare-handle="'+product.handle+'"><cart-opener data-modal="#PopupModal-addtocart"><a href="'+ product.url +'" class="btn--link active btn-add-to-cart" data-vid="'+ variants[0].id +'" data-title="'+ theme.strings.addToCartText +'"><span>'+ theme.strings.addToCartText +'</span></a></cart-opener></td>';
          }
        } else {
          pCart = '<td data-compare-handle="'+product.handle+'"><a href="'+ product.url +'" class="btn--link active btn-soldout" data-title="'+ theme.strings.soldOutText +'"><span>'+ theme.strings.soldOutText +'</span></a></td>';
        }
        var pType = '<td data-compare-handle="'+product.handle+'"><span>-</span></td>';
        if (product.type) {
          pType = '<td data-compare-handle="'+product.handle+'"><span>' + product.type + '</span></td>';
        }
        var pVendor = '<td data-compare-handle="'+product.handle+'"><span>-</span></td>';
        if (product.vendor) {
          pVendor = '<td data-compare-handle="'+product.handle+'"><span>' + product.vendor + '</span></td>';
        }

        this.querySelector('tr.compare-image').innerHTML += pImage;
        this.querySelector('tr.compare-title').innerHTML += pTitle;
        this.querySelector('tr.compare-price').innerHTML += pPrice;
        this.querySelector('tr.compare-cart').innerHTML += pCart;
        this.querySelector('tr.compare-type').innerHTML += pType;
        this.querySelector('tr.compare-vendor').innerHTML += pVendor;
      }
}
customElements.define('compare-dialog', CompareDialog);
    
class QuickviewDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'QUICKVIEW-DIALOG') {
          this.hide();
      }
    });
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }
  show(opener) {
    this.opener = opener
    var href = this.opener.getAttribute('href');
    var quickview = href.includes("?") ? "&view=quickview" : "?view=quickview"
    this.setAttribute('open', '');
    fetch(href + quickview)
      .then(response => response.text())
      .then((text) => {
        const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
        var pHtml = "";
        if (typeof ProductForm == 'undefined') {
          // remove script tag
          var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

          parsedHTML.querySelectorAll('noscript link').forEach((link) => {
            pHtml += link.outerHTML;
          })
          parsedHTML.querySelectorAll('script[defer="defer"]').forEach((script) => {
            pHtml += script.outerHTML;
          })
        } else {
          parsedHTML.querySelectorAll('noscript link').forEach((link) => {
            pHtml += link.outerHTML;
          })
        }
        if(parsedHTML.querySelector('#product_quickview .container .row')) {
          pHtml += parsedHTML.querySelector('#product_quickview .container .row').innerHTML;
        }
        this.querySelector('.quickview-popup-content').innerHTML = pHtml;
        if (typeof ProductForm == 'undefined') {
          //eval code to trigger event
          var scripts = this.querySelector('.quickview-popup-content').querySelectorAll("script[src]");
          scripts.forEach(function(script){
            getScript(script.getAttribute("src"));
          })
        }
        this.quickViewSlick();
        
      })
  }

  quickViewSlick() {
    if ($('#PopupModal-quickview .gp-product-media-wrapper').length) {
      $('#PopupModal-quickview #gp-media-main-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        draggable: false,
        prevArrow: '<i class="theme-iconback"></i>',
        nextArrow: '<i class="theme-iconnext"></i>',
        infinite: true,
        adaptiveHeight: false,
        swipe: false
      });
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.querySelector('quickview-dialog .quickview-popup-content').innerHTML = '';    
    this.removeAttribute('open');
  }
}
customElements.define('quickview-dialog', QuickviewDialog);


class CartDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('.mfp-close').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    document.querySelector('#close-cartopener').addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('#PopupModal-addtocart').removeAttribute('open');
    })
  }  

  async show(lineitem, opened, quantity) {
    var subtotal = await this.getCart();
    if (lineitem) {
      var quantity = parseInt(quantity) || 1;
      var pName = lineitem.title;
      var pImage = lineitem.image;
      this.querySelector('.product-confirm-name').innerHTML = pName;
      this.querySelector('.popup__image-wrapper').innerHTML = '<img src="'+ pImage +'" />';
      this.querySelector('.product-confirm-subtotal .price').innerHTML = subtotal;
      this.querySelector('.product-confirm-qty .value').innerHTML = quantity;
      var itemText = this.querySelector('.ajax_header .one-item-text').innerHTML;
      if (quantity > 1) {
        itemText = this.querySelector('.ajax_header .other-item-text').innerHTML;
      }
      this.querySelector('.ajax_header .item-added-to-cart').innerHTML = quantity + ' ' + itemText;
      this.setAttribute("open", "")
    }
  }

  hide() {
    this.removeAttribute("open");
  }
  getCart() {
    var result = fetch(`${routes.cart_url }`)
      .then((response) => response.text())
      .then((text) => {
          var html  = new DOMParser().parseFromString(text, 'text/html');
          if(html.querySelector(".cart-subtotal__price")) {
            var subtotal = html.querySelector(".cart-subtotal__price").innerHTML
          }
          if(html.querySelector(".action-cart .counter-number")) {
            var counter_number = html.querySelector(".action-cart .counter-number").innerHTML
          }
          
          if(document.querySelector(".action-cart .counter-number")) {
            document.querySelectorAll(".action-cart .counter-number").forEach((number) => {
              number.innerHTML = counter_number
            })
          }

          return subtotal
      })
      .catch((e) => {
        console.error(e);
      });
    return result
  }
}

customElements.define("cart-dialog", CartDialog)

class CartOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('a');
    if(this.button) {
      this.button.addEventListener('click', (e) => {

        this.button.classList.add('ajax-loader-btn');
        e.preventDefault();
        this.addCart();
      });
    }
  }

  addCart() {
    this.vId = this.button.getAttribute("data-vid");

    const body = JSON.stringify({
        id: this.vId,
        quantity: 1
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((lineitem) => {
        if (lineitem.status != 422) {
          document.querySelector(this.getAttribute('data-modal'))?.show(lineitem, this.button);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(this.button) {
          this.button.classList.remove('ajax-loader-btn');
          this.button.removeAttribute('disabled');
          refreshMiniCart()
        }
      });
  }

}
customElements.define('cart-opener', CartOpener);